module.exports = __webpack_public_path__ + "static/media/Talia Trepte.5c77c207.jpg";